<div class="panel rs-no-padding" *ngIf="shouldDisplayPanel">
  <lib-generic-message-box
    [messageType]="messageBoxTypeInformation"
    [showCross]="false"
    [cypressTag]="'newCustomer'"
  >
    <ng-container Title>{{
      'bills.evolutionChart.web.newCustomerInfoBoxTitle' | translate
    }}</ng-container>
    <p Content>
      {{ 'bills.evolutionChart.web.newCustomerInfoBoxDescription' | translate }}
    </p>
  </lib-generic-message-box>
</div>
